import React from 'react';
import { Input, Form } from 'antd';
import { injectIntl } from 'react-intl';
import PersonalInformationContext from './PersonalInformationContext';
import { validatePhoneIgnoringHyphensAndBraces } from '../../Utils/FormValidators';
import message from '../../Containers/ManualSearchV2/ManualSearchMessages';

const { Item } = Form;

function Phone(props) {
  const { initialValue, isNameMasked ,intl} = props;
  const { form } = React.useContext(PersonalInformationContext);

  return (
    <Item colon={false}>
      {form.getFieldDecorator('Mobile', {
        initialValue,
        rules: [
          {
            validator: validatePhoneIgnoringHyphensAndBraces,
          },
        ],
      })(<Input style={{ overflow: 'hidden' }} placeholder={intl.formatMessage({ ...message.enterPhoneLabel })} disabled={isNameMasked} />)}
    </Item>
  );
}

export default (injectIntl(Form.create()(Phone)));
export { Phone as PhoneWithoutIntl };
